const initialState = {
	admissionPageInfo: {},
    isAdmissionsOpen: false,
	login_restricted: true
}

export default (state = initialState, action) => {
	const { type, payload } = action;
	let newState;
	switch (type) {
		case 'CLEAR_ADMISSION_STATE':
			newState = initialState;
			break;
		case 'SIGNUP_LOADING':
			newState = { ...state, isLoading: payload };
			break;
		case 'STUDENT_LOGIN':
			newState = { ...state, isStudentLoading: payload, studentLoginCalled: !payload };
			break;
        case 'COURSES_LOADING': 
            newState = { ...state, isCoursesLoading: payload };
            break;
        case 'ADMISSION_PAGE_INFO_LOADING':
            newState = { ...state, isAdmissionPageInfoLoading: payload };
            break;
        case 'GET_ADMISSION_PAGE_INFO_LOADING':
            newState = { ...state, isFetchingExistingAdmsnPageInfo: payload };
            break;
		case 'ADMISSION_PAGE_INFO_LOADED':
			newState = { ...state, isAdmissionPageInfoLoaded: payload, admissionPageInfoFailed: !payload };
            break;
		case 'USER_PROFILE_LOADING':
			newState = { ...state, isUserProfileLoading: payload };
			break;
        case 'SAVE_ADMISSION_PAGE_INFO':
            newState = { ...state, admissionPageInfo: payload };
            break;
        case 'UPDATE_ADMISSIONS_OPEN_INFO':
            newState = { ...state, isAdmissionsOpen: payload };
            break;
		case 'FETCH_REGISTRATIONS':
			newState = {...state, fetchingReg: payload.fetchingReg, fetchRegSuccess: payload.isSuccess};
			break;
		case 'SAVE_REGISTRATIONS':
			newState = {...state, filteredReg: payload.registrations};
			break;
		case 'UPDATE_REGISTRATIONS': 
			newState = {...state, filteredReg: payload.registrations};
			break;
		case 'RESET_REG':
			newState = {...state, isAdmissionsOpen: false, admissionPageInfo: {}, isAdmissionPageInfoLoaded: false};
			break;
		case 'UPDATE_STUDENT_PASSWORD':
			newState = {...state, studentPassUpdating: payload};
			break;
		case 'SET_SERCH_STUDENT_PROFILE':
			newState = {...state, studentProfile: payload};
			break;
		case 'STUDENT_RESTRICTION':
			newState = {...state, ...payload};
			break;
		default:
			newState = state;
			break;
	}
	return newState;
}